import { SettingsSection } from './SettingsSection';
import { SettingsTranslationKeys } from '../../../api/models/TranslationKeys';
import { SettingsButton } from '../components/SettingsButton';
import { TokenApi } from '../../../api/bootstrap/TokenApi';
import { BootstrapApi } from '../../../api/bootstrap/BootstrapApi';
import { Log, Router } from '@lightningjs/sdk';
import { ScrollList } from '../../../components/shared/ScrollList';
import { Backend } from '../../../api/Backend';

export class UserSection extends SettingsSection {
  constructor(backend: Backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_application_customer));
  }

  addControls(list: ScrollList) {
    super.addControls(list);
    this.addLogoutButton(list);
  }

  private addLogoutButton(list: ScrollList) {
    list.items.childList.a({
      type: SettingsButton,
      data: {
        topLine: this.backend.sessionInfo.customer.loginName,
        bottomLine: this.backend.translations.forKey(SettingsTranslationKeys.settings_logout),
        action: () => {
          this.backend.playerController.endStream();
          BootstrapApi.sessionLogout(this.backend)
            .then(() => {
              this._finishLogout();
            })
            .catch(err => {
              Log.warn('Logout request error', err);
              this._finishLogout();
            });
        },
      },
      passSignals: {
        onActivate: true,
      },
    });
  }

  _finishLogout() {
    this.backend.clearSession();
    TokenApi.removeSaved();
    Router.navigate('login');
  }
}
